import React, { useState } from 'react';
import { ImageInput, useMutation } from 'react-admin';
import { S3 } from 'aws-sdk';
import AWS from "aws-sdk";
import { SimpleForm, FileInput, TextInput, BooleanInput, Create } from 'react-admin';
import UploadImages from '../products/UploadImages';

const InfluencerCreate = (props: any) => {

  const BUCKET_NAME = "mazola-prod";
  const s3 = new AWS.S3({
    region: process.env.REACT_APP_REGION,
    secretAccessKey: process.env.REACT_APP_SECRET,
    accessKeyId: process.env.REACT_APP_ACCESS_KEY,
  });

  const [image, setImage] = useState(null);
  const [url, setUrl] = useState('');
  const [createInfluencer, { loading, error }] = useMutation();

  const handleImageChange = async (event: any) => {
    const imageFile = event.target.files[0];
    setImage(imageFile);

    const data = imageFile;
    const uploadToS3 = async (data:any) => {
      const name = imageFile.name;
      await s3
        .putObject({
          Key: name,
          Bucket: BUCKET_NAME,
          ContentType: "image/jpg",
          Body: data,
          ACL: "public-read",
        })
        .promise();
      return `https://${BUCKET_NAME}.s3.${process.env.REACT_APP_REGION}.amazonaws.com/${name}`;
    };
    const url = await uploadToS3(data);
    setUrl(url)
    // setUrl(`https://${process.env.REACT_APP_AWS_BUCKET_NAME}.s3.amazonaws.com/${Key}`);
  };

  return (
    <Create {...props}>
      <SimpleForm>
        {error && <p>Error uploading image</p>}
        <UploadImages sourceName="featured_image" multiple={false} />
        {/* <UploadImages sourceName="images" multiple={true} /> */}
        <TextInput source="name_en" />
        <TextInput source="name_ar" />
        <TextInput source="video_url" />
        <BooleanInput source="active" />
      </SimpleForm>
    </Create>
  );
};

export default InfluencerCreate;
